var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.435,
    height: 25.381,
    viewBox: "0 0 37.435 25.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31892",
    x: 0,
    y: 0,
    width: 37.435,
    height: 25.381,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31895",
    "data-name": "Rectangle 31895",
    width: 34.434,
    height: 22.38,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CA-Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31892-2",
    "data-name": "Rectangle 31892",
    width: 34.435,
    height: 22.381,
    transform: "translate(1.5 0.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31893",
    "data-name": "Rectangle 31893",
    width: 5.128,
    height: 22.381,
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31894",
    "data-name": "Rectangle 31894",
    width: 5.128,
    height: 22.381,
    transform: "translate(29.307)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14126",
    "data-name": "Group 14126",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14125",
    "data-name": "Group 14125",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40603",
    "data-name": "Path 40603",
    d: "M19.8,9.7l-.827-.4a.337.337,0,0,1-.177-.391l.683-2.438,0-.007-2.111.5a.356.356,0,0,1-.424-.25l-.274-.975-.009,0L14.842,7.786a.277.277,0,0,1-.48-.234l.765-4.186-.009-.007-1.112.606a.407.407,0,0,1-.555-.166L12.073,1.271h0L10.687,3.8a.406.406,0,0,1-.555.166L9.021,3.359l-.007.007.762,4.186a.276.276,0,0,1-.477.234L7.487,5.735l-.009,0L7.2,6.712a.356.356,0,0,1-.424.25l-2.108-.5-.007.007.683,2.438a.336.336,0,0,1-.175.391l-.829.4v.009l3.691,3.023a.6.6,0,0,1,.186.645l-.309.941,0,.007,3.693-.506a.252.252,0,0,1,.285.259l-.126,3.96h.608l-.126-3.96a.256.256,0,0,1,.086-.2.253.253,0,0,1,.2-.06l3.693.506.007-.007-.312-.941a.593.593,0,0,1,.188-.645L19.8,9.708l0-.009",
    transform: "translate(5.254 1.537)",
    fill: "red"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaFlag);
export default __webpack_public_path__ + "static/media/CA-Flag.4acae95146474a9bd81062cbe836ec03.svg";
export { ForwardRef as ReactComponent };